import { upload } from "@vercel/blob/client";
import { UserStore } from "@/app/stores/UserStore";
import { ULogger } from "@/app/utils/ULogger";
import { UStorage } from "@/app/utils/UStorage";
import { Globals } from "@/app/vars/Globals";
import { Sizes } from "@/app/vars/Sizes";

export type PreparedInsoleUpload = { file?: File; fileUrl?: string };

export function isValidInsoleFile(file: File): boolean {
  if (file.size === 0 || file.size > Sizes.MAX_INSOLE_MODEL_FILE_BYTES) {
    return false;
  }

  return file.name.toLowerCase().endsWith(Globals.INSOLE_MODEL_FILE_EXTENSION);
}

export function isValidPreviewImage(file: File): boolean {
  if (file.size === 0 || file.size > Sizes.MAX_INSOLE_MODEL_PREVIEW_BYTES) {
    return false;
  }

  return file.type.startsWith("image/");
}

export async function prepareInsoleUpload(
  file: File,
  isPublic: boolean,
): Promise<PreparedInsoleUpload> {
  if (!Globals.IS_PROD_ENV) {
    return { file };
  }

  const userUuid = UserStore.getState().user?.uuid ?? "";
  const pathname = UStorage.insoleModelPath(isPublic, userUuid);

  try {
    const blob = await upload(pathname, file, {
      access: "public",
      handleUploadUrl: "/api/upload",
      contentType: "application/octet-stream",
    });

    return { fileUrl: blob.url };
  } catch (error) {
    ULogger.error("InsoleUpload", "blob client upload failed", error);
    throw error;
  }
}

export async function preparePreviewUpload(
  file: File,
  isPublic: boolean,
): Promise<PreparedInsoleUpload> {
  if (!Globals.IS_PROD_ENV) {
    return { file };
  }

  const userUuid = UserStore.getState().user?.uuid ?? "";
  const pathname = UStorage.insoleModelPreviewPath(
    isPublic,
    userUuid,
    UStorage.fileExtension(file.name),
  );

  try {
    const blob = await upload(pathname, file, {
      access: "public",
      handleUploadUrl: "/api/upload",
      contentType: file.type,
    });

    return { fileUrl: blob.url };
  } catch (error) {
    ULogger.error("InsoleUpload", "preview upload failed", error);
    throw error;
  }
}
